export const AustraliaRegionsIds = {
  NSW: 0,
  VIC: 1,
  QLD: 2,
  SA: 3,
  WA: 4,
  TAS: 5,
  ACT: 7,
  NT: 6
}

export const AustraliaRegionsNames = {
  NSW: 'New South Wales',
  VIC: 'Victoria',
  QLD: 'Queensland',
  SA: 'South Australia',
  WA: 'Western Australia',
  TAS: 'Tasmania',
  ACT: 'Australian Capital Territory',
  NT: 'Northern Territory'
}

export const AustraliaRegionsOptions = Object.keys(AustraliaRegionsIds).map(key => ({
  value: key,
  label: AustraliaRegionsNames[key]
}))
